<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      class="form"
      label-width="30%"
    >
      <!-- <el-form-item label="账户" prop="account">
        <el-input
          v-model.trim="form.account"
          placeholder="请输入账户"
          class="inputWidth"
          :disabled="isInput"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          v-model.trim="form.password"
          placeholder="请输入密码"
          class="inputWidth"
          :disabled="isInput"
          clearable
        ></el-input>
      </el-form-item> -->
      <el-form-item label="Appkey" prop="appKey">
        <el-input
          v-model.trim="form.appKey"
          placeholder="请输入Appkey"
          class="inputWidth"
          :disabled="isInput"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="secret" prop="secret">
        <el-input
          v-model.trim="form.secret"
          placeholder="请输入secret"
          class="inputWidth"
          :disabled="isInput"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="AccessToken" prop="accessToken">
        <el-input
          type="textarea"
          :rows="2"
          disabled
          v-model.trim="form.accessToken"
          placeholder="请输入AccessToken"
          class="inputWidth"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="6" :offset="7" class="btns">
        <el-button size="small" plain @click="cancel" v-if="!isInput"
          >取消</el-button
        >
        <el-button size="small" type="success" plain @click="confirm" v-if="!isInput"
          >确定</el-button
        >
        <el-button size="small" type="warning" plain @click="edit" v-else
          >编辑</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>
           
<script>
export default {
  data() {
    return {
      form: {},
      rules: {
        account: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          { min: 1, max: 20, message: "长度在 1到 20 个字符" },
        ],
        password: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          { min: 6, max: 16, message: "长度在 6 到 16 个字符" },
        ],
        appKey: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          { min: 1, max: 50, message: "长度在 1到 50 个字符" },
        ],
        secret: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          { min: 1, max: 50, message: "长度在 1到 50 个字符" },
        ],
      },
      // 表单状态
      isInput: true,
    };
  },
  methods: {
    // 取消
    cancel() {
      // 1.表单禁用
      this.isInput = true;
      // 2.获取数据
      this.getSave();
      console.log(this.list, "this.list");
    },
    // 确定
    confirm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // 1. 修改数据
          let params = Object.assign({}, this.form);
          this.$postJson("dmc/yingShiConfig/save", params).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                message: res.message,
                type: "success",
              });
              // 2.表单禁用
              this.isInput = true;
            } else {
              this.$message.error(res.message);
            }
            this.getSave();
          });
        }
      });
    },
    // 修改
    edit() {
      // 1.表单启用
      this.isInput = false;
    },
    // 查询数据
    getSave() {
      this.$postJson("dmc/yingShiConfig/select").then((res) => {
        if (res.code == 200) {
          this.form = Object.assign({}, res.result);
        }
      });
    },
  },
  created() {
    this.getSave();
  },
};
</script>
<style scoped lang="scss">
.form {
  padding-top: 50px;
}
.inputWidth {
  width: 300px;
}
.btns {
  display: flex;
  justify-content: center;
}
</style>